<template>
  <div class="agGridTable" ref="root">
    <ag-grid-vue
      style="width: 100%;"
      class="ag-theme-alpine"
      :key="paginationPageSize"
      :defaultColDef="defaultColDef"
      :columnDefs="getColumnsDefault"
      :rowData="data"
      :getRowClass="getRowClass"
      ref="agGrid"
      :domLayout="'autoHeight'"
      :headerHeight="29"
      :rowHeight="rowHeight"
      :minHeight="0"
      @grid-ready="onGridReady"
      @column-moved="onDragStopped"
      :paginationPageSize="paginationPageSize"
      :pagination="true"
      :localeText="localeTextTR"
      :rowClassRules="rowClassRules"
      :floatingFilter="floatingFilter"
      @cell-clicked="onCellClicked"
      @cell-double-clicked="onCellDoubleClicked"
      :autoGroupColumnDef="{ minWidth: 200 }"
      :rowGroupPanelShow="rowGroupPanelShow ? 'always' : 'never'"
      :doesExternalFilterPass="doesExternalFilterPass"
      :suppressDragLeaveHidesColumns="true"
      @pagination-changed="onPaginationChanged"
      :getContextMenuItems="addContextMenuItem"
    >
    </ag-grid-vue>
    <div
      class="foot row align-items-center justify-content-between p-10"
      v-if="pager.rowCount > 0"
    >
      <div class="col-sm col-12">
        <p>
          {{ pager.rowCount }} kayıttan
          {{ pager.currentPage * pager.pageSize + 1 }} ile
          <template
            v-if="(pager.currentPage + 1) * pager.pageSize < pager.rowCount"
          >
            {{ (pager.currentPage + 1) * pager.pageSize }}
          </template>
          <template
            v-if="(pager.currentPage + 1) * pager.pageSize >= pager.rowCount"
          >
            {{ pager.rowCount }}
          </template>
          kayıtları görüyorsunuz.
        </p>
      </div>
      <div class="col-sm-auto col-12">
        <formGroup as="select" v-model="paginationPageSize" :errors="{}">
          <template #input>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
          </template>
        </formGroup>
      </div>
      <div class="col-sm-auto col-12 p-l-0" v-if="pager.totalPages > 1">
        <div role="group" class="btn-group">
          <template v-for="item in pager.totalPages" :key="item">
            <button
              type="button"
              class="btn btn-sm"
              :class="
                item - 1 == pager.currentPage ? 'btn-info' : 'btn-secondary'
              "
              v-if="isShowPageNumber(item)"
              @click="gridApi.paginationGoToPage(item - 1)"
            >
              {{ item }}
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Bu userId'lere VEYA e-postalara sahip kisiler icin row acma tek-tik yerine
// CIFT-tik olur. (Diger herkes normal tek-tik davranisinda kalir.)
const DOUBLE_CLICK_USER_IDS = [1330];
const DOUBLE_CLICK_EMAILS = ["turgut@resbox.com"];

// ag-grid'in varsayilan text filter karsilastirmasi duz toLowerCase() kullanir;
// Turkce'de 'I' -> 'i' ('ı' degil) ve 'İ' -> 'i' + birlesik nokta (U+0307)
// donusumu yuzunden BUYUK harfli degerler kucuk harf aramayla eslesmez
// (or. "BETÜL ÇIKAN" icinde "çıkan" bulunamaz, "İREM" icinde "irem" bulunamaz).
// Dis kaynakli veride ayrik aksan (NFD) karakterler de ayni sekilde kacirir.
// Formatter hem yazilan arama metnine hem hucre degerine uygulanir:
// NFC normalize + trim + tr-TR kucuk harf.
const trTextFormatter = function(from) {
  if (from == null) return null;
  return from
    .toString()
    .normalize("NFC")
    .trim()
    .toLocaleLowerCase("tr-TR");
};

export default {
  name: "dataTable",
  props: {
    name: String,
    data: Array,
    columnDefs: Array,
    rowHeight: {
      type: Number,
      default: 30,
    },
    rowGroupPanelShow: {
      type: Boolean,
      default: true,
    },
    rowClassRules: {
      type: Object,
      default: null,
    },
    doesExternalFilterPass: {
      type: Function,
      default: null,
    },
    floatingFilter: {
      type: Boolean,
      default: true,
    },
    addContextMenuItem: {
      type: Function,
    },
  },
  data() {
    return {
      gridApi: null,
      // En son "islem" yapilan (tiklanan) satirin Id'si. Modal acilip kapaninca
      // kullanicinin nerede kaldigini gostermek icin isaretlenir.
      lastRowId: null,
      gridColumnApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: this.floatingFilter,
        // Kolon bazli filterParams ile deep-merge edilir (ezilmez); text ve
        // set filtrelerin tamami Turkce-duyarli arama yapar.
        filterParams: {
          textFormatter: trTextFormatter,
        },
      },
      pager: {
        pageSize: 0,
        currentPage: 0,
        totalPages: 0,
        rowCount: 0,
      },
      paginationPageSize: 25,
    };
  },
  created() {},
  methods: {
    // Tik-modu: cift-tik listesindeki kullanici icin tek-tik BASTIRILIR, "islem"
    // (cellClicked) CIFT-tikta yayilir. Diger herkeste tek-tik aynen calisir.
    // Boylece 59 ekranin @cellClicked="detailShow=..." mantigi degismeden, sadece
    // listedeki kisi row'u cift-tikla acar. Ekran-basi degisiklik gerekmez.
    isCheckCell(e) {
      // Interaktif secim/checkbox hucresi mi? -> cift-tik modunda da TEK tikla
      // secilebilmeli. Isaret: field "isSelected" (proje konvansiyonu) veya
      // colDef.checkCell:true (yeni kolonlar icin opt-in). NOT: ag-grid v27
      // cellRenderer'i klonladigi icin renderer kimlik (===) karsilastirmasi
      // guvenilir DEGIL; o yuzden kullanmiyoruz.
      if (!e || !e.colDef) return false;
      return e.colDef.field === "isSelected" || e.colDef.checkCell === true;
    },
    onCellClicked(e) {
      // Cift-tik modunda tek-tik bastirilir (row cift-tikla acilir). ISTISNA:
      // checkbox/secim hucresi -> tek tikla secilsin.
      if (this.clickMode === "double" && !this.isCheckCell(e)) return;
      // Checkbox hucresi coklu secim icindir, "nerede kaldim" isaretini oynatmaz.
      if (!this.isCheckCell(e)) this.markLastRow(e);
      this.$emit("cellClicked", e);
    },
    onCellDoubleClicked(e) {
      if (!this.isCheckCell(e)) this.markLastRow(e);
      this.$emit("cellDoubleClicked", e); // mevcut cift-tik dinleyicileri korunur
      // Cift-tik modunda "islem"i (tek-tik dinleyicileri) cift-tikta tetikle;
      // checkbox hucresi tek-tikta zaten islendi -> burada tekrar emitleme.
      if (this.clickMode === "double" && !this.isCheckCell(e)) {
        this.$emit("cellClicked", e);
      }
    },
    // Satir sinifi. STABIL METOD REFERANSI olmali: inline fonksiyon her render'da
    // yeni referans uretir -> ag-grid deep-watch -> header rebuild -> floating
    // filter'da yazarken imlec kacar.
    getRowClass(params) {
      const id = params && params.data ? params.data.Id : undefined;
      const base = "rowSelectClass" + this.name + "" + id;
      // id == null kontrolu SART: Id'si olmayan grid'lerde undefined === undefined
      // olur ve TUM satirlar isaretli gorunurdu.
      if (id != null && this.lastRowId != null && id === this.lastRowId) {
        return [base, "kr-row-last"];
      }
      return base;
    },
    markLastRow(e) {
      const id = e && e.data ? e.data.Id : undefined;
      if (id == null) return; // Id'siz grid -> isaretleme yok
      if (this.lastRowId === id) return;
      this.lastRowId = id;
      // ag-grid getRowClass'i veri degisiminde kendiliginden yeniden calistirmaz;
      // anlik geri bildirim icin sinifi elle tasi. getRowClass ise siralama/
      // filtreleme/sayfa degisiminde satir yeniden uretildiginde geri koyar.
      //
      // Sorgu KOKUN ICINDE, document'ta DEGIL: 109 dataTable kullanimindan 3'u
      // `name` prop'u gecmiyor (rowSelectClassundefined). Ayni sayfada iki
      // isimsiz grid varsa (or. roomAvailibility main + detail modali) document
      // taramasi isareti yanlis grid'e tasirdi.
      const rootEl = this.$refs.root;
      if (!rootEl) return;
      rootEl
        .querySelectorAll(".kr-row-last")
        .forEach((el) => el.classList.remove("kr-row-last"));
      rootEl
        .querySelectorAll(".rowSelectClass" + this.name + "" + id)
        .forEach((el) => el.classList.add("kr-row-last"));
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.$emit("gridReady", params);
    },
    onDragStopped(event) {
      var data = [];
      event.columnApi.getState().forEach((element) => {
        data.push(element.colId);
      });
      var agGridCof =
        localStorage.getItem("agGridCof6") == undefined
          ? {}
          : JSON.parse(localStorage.getItem("agGridCof6"));
      agGridCof[this.name] = this.getColumnsDefault
        .filter((x) => {
          return x.type != "action";
        })
        .sort((x, y) => {
          return data.indexOf(x.field) - data.indexOf(y.field);
        });
      localStorage.setItem("agGridCof6", JSON.stringify(agGridCof));
    },
    onPaginationChanged() {
      if (this.gridApi) {
        this.pager.pageSize = this.gridApi.paginationGetPageSize();
        this.pager.currentPage = this.gridApi.paginationGetCurrentPage();
        this.pager.totalPages = this.gridApi.paginationGetTotalPages();
        this.pager.rowCount = this.gridApi.paginationGetRowCount();
      }
    },
    isShowPageNumber(no) {
      var returns = [];
      for (let index = 1; index < this.pager.totalPages + 1; index++) {
        if (this.pager.currentPage - 3 < index && returns.length < 7) {
          returns.push(index);
        }
      }
      if (returns.length < 7) {
        for (
          let index = returns[0] - (7 - returns.length);
          index < returns[0];
          index++
        ) {
          returns.push(index);
        }
      }
      return returns.indexOf(no) > -1 ? true : false;
    },
    addRow(item) {
      this.gridApi.applyTransaction({ add: item });
    },
    changeRow(isCheckColumn, item) {
      for (
        let index = 0;
        index < this.gridApi.getDisplayedRowCount();
        index++
      ) {
        let agRow = this.gridApi.getDisplayedRowAtIndex(index).data;
        if (agRow != undefined && agRow[isCheckColumn] == item[isCheckColumn]) {
          Object.keys(item).forEach((key) => {
            agRow[key] = item[key];
          });
          this.gridApi.applyTransaction({ update: [agRow] });
        }
      }
    },
    removeRow(item) {
      this.gridApi.applyTransaction({ remove: item });
    },
    selectRow(item) {
      document
        .querySelectorAll(
          '[class^="rowSelectClass' +
            this.name +
            '"], [class*=" rowSelectClass' +
            this.name +
            '"]'
        )
        .forEach((element) => {
          element.classList.remove("select");
        });
      item.forEach((one) => {
        document
          .querySelectorAll(".rowSelectClass" + this.name + "" + one)
          .forEach((element) => {
            element.classList.add("select");
          });
      });
    },
  },
  computed: {
    // vuex user.UserId cift-tik listesinde VEYA user.Email cift-tik e-posta
    // listesinde ise 'double', degilse 'single'. (Email string -> trim+lowercase.)
    clickMode() {
      const u = this.$store && this.$store.state ? this.$store.state.user : null;
      if (!u) return "single";
      const byId = DOUBLE_CLICK_USER_IDS.indexOf(Number(u.UserId)) > -1;
      const email = (u.Email || "").toString().trim().toLowerCase();
      const byEmail = DOUBLE_CLICK_EMAILS.indexOf(email) > -1;
      return byId || byEmail ? "double" : "single";
    },
    getColumnsDefault() {
      var app = this;
      if (
        this.columnDefs == undefined &&
        (localStorage.getItem("agGridCof6") == undefined ||
          JSON.parse(localStorage.getItem("agGridCof6"))[this.name] ==
            undefined)
      ) {
        var data = [];
        if (this.data != null && this.data.length > 0) {
          Object.keys(this.data[0]).forEach((element) => {
            var colDef = {
              headerName: element,
              field: element,
              enableRowGroup: true,
              floatingFilter: true,
              filter: "agTextColumnFilter",
              flex: 1,
              minWidth: 140,
            };
            if (typeof this.data[0][element] == "boolean") {
              colDef.filter = false;
              colDef.floatingFilter = false;
              colDef.cellRenderer = app.$CheckCellRenderer;
            }
            // if(){

            // }
            data.push(colDef);
          });
        }
        data.push({
          headerName: "",
          type: "action",
          width: 75,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
          cellRenderer: app.$BtnCellRenderer,
          cellRendererParams: {
            clicked: function(field) {
              app.$emit(field.emit, field.data);
            },
          },
        });
        return data;
      } else {
        if (
          localStorage.getItem("agGridCof6") != undefined &&
          JSON.parse(localStorage.getItem("agGridCof6"))[this.name] != undefined
        ) {
          var columnDefs = [];
          // JSON.parse(localStorage.getItem("agGridCof6"))[this.name]
          JSON.parse(localStorage.getItem("agGridCof6"))[this.name].forEach(
            (prop) => {
              var isPush = false;
              let fixProp = { ...prop };
              if (this.columnDefs != undefined) {
                this.columnDefs.forEach((element) => {
                  if (fixProp.field == element.field) {
                    isPush = true;
                    fixProp = element;
                  }
                });
              } else {
                isPush = true;
              }
              if (isPush) {
                columnDefs.push(fixProp);
              }
            }
          );

          if (this.columnDefs != undefined) {
            this.columnDefs.forEach((prop) => {
              var isPush = false;
              JSON.parse(localStorage.getItem("agGridCof6"))[this.name].forEach(
                (element) => {
                  if (prop.headerName == element.headerName) {
                    isPush = true;
                  }
                }
              );
              if (!isPush) {
                if (prop.type == "action") {
                  prop = {
                    ...prop,
                    cellRenderer: app.$BtnCellRenderer,
                    cellRendererParams: {
                      clicked: function(field) {
                        app.$emit(field.emit, field.data);
                      },
                    },
                  };
                }
                columnDefs.push(prop);
              }
            });
          } else {
            columnDefs.push({
              headerName: "",
              type: "action",
              width: 75,
              buttons: [
                {
                  classes: "btn btn-xs waves-effect waves-light btn-warning",
                  text: '<i class="fas fa-pencil-alt"></i>',
                  emit: "update",
                },
                {
                  classes: "btn btn-xs waves-effect waves-light btn-danger",
                  text: '<i class="fas fa-trash-alt"></i>',
                  emit: "remove",
                },
              ],
              filter: false,
              sortable: false,
              resizable: false,
              floatingFilter: false,
              cellRenderer: app.$BtnCellRenderer,
              cellRendererParams: {
                clicked: function(field) {
                  app.$emit(field.emit, field.data);
                },
              },
            });
          }
          return columnDefs;
        } else {
          var columnDef = this.columnDefs;
          columnDef.forEach((element, index) => {
            if (element.type == "action") {
              columnDef[index] = {
                ...element,
                cellRenderer: app.$BtnCellRenderer,
                cellRendererParams: {
                  clicked: function(field) {
                    app.$emit(field.emit, field.data);
                  },
                },
              };
            }
          });
          return columnDef;
        }
      }
    },
    localeTextTR() {
      return {
        // for filter panel
        page: "Sayfa",
        more: "Devamı",
        to: "To",
        of: "-",
        next: "İleri",
        last: "Son",
        first: "İlk",
        previous: "Sonraki",
        loadingOoo:
          '<div class="loadArea"><b class="fa fa-spinner fa-spin"></b></div>',

        // for set filter
        selectAll: "Tümünü seç",
        searchOoo: "Ara...",
        blanks: "Boş",

        // for number filter and text filter
        filterOoo: "Ara...",
        applyFilter: "Arama...",
        equals: "Eşittir",
        notEquals: "Eşit değilse",

        lessThan: "Küçüktür",
        greaterThan: "Büyüktür",
        lessThanOrEqual: "Küçük eşit",
        greaterThanOrEqual: "Büyük eşit",
        inRange: "Aralık",

        // for text filter
        contains: "İçeriyorsa",
        notContains: "İçermiyorsa",
        startsWith: "Başlıyorsa",
        endsWith: "Bitiyorsa",

        // the header of the default group column
        group: "Grup",

        // tool panel
        columns: "Sütunlar",
        filters: "Süzme",
        rowGroupColumns: "Pivot Sütun",
        rowGroupColumnsEmptyMessage: " sütunları gruba sürükle",
        valueColumns: "Sütun Değeri",
        pivotMode: "Pivot-Modu",
        groups: "Gruplar",
        values: "Değerler",
        pivots: "Pivotlar",
        valueColumnsEmptyMessage: " toplamak için sütunları sürükleyin",
        pivotColumnsEmptyMessage: " pivot için buraya sürükleyin",
        toolPanelButton: "Araç çubuğu",

        // other
        noRowsToShow: "Daha önce veri eklenmemiş.",

        // enterprise menu
        pinColumn: "Stünu sabitle",
        valueAggregation: "Değer",
        autosizeThiscolumn: "Sığdır",
        autosizeAllColumns: "Sütunları tomatik boyutlandır",
        groupBy: "Grupla",
        ungroupBy: "Gruplama",
        resetColumns: "Sütunları sıfırla",
        expandAll: "Hepsini aç",
        collapseAll: "Hepsini kapat",
        toolPanel: "Araç paneli",
        export: "Çıkart",
        csvExport: "CSV ye çıkar",
        excelExport: "Excel e aktar",

        // enterprise menu pinning
        pinLeft: "Sola yasla <<",
        pinRight: "Sağa yasla >>",
        noPin: "Yaslama <>",

        // enterprise menu aggregation and status panel
        sum: "Sum",
        min: "En az",
        max: "En çok",
        none: "Yok",
        count: "Say",
        verage: "Ortalama",

        // standard menu
        copy: "Kopyala",
        copyWithHeaders: "Başlığı kopyala",
        ctrlC: "ctrl C",
        paste: "Yapıştır",
        ctrlV: "ctrl C",
      };
    },
  },
};
</script>

<style>
.agGridTable {
  margin: -1px -1px 0;
}
.ag-theme-alpine .ag-paging-panel {
  margin-top: -1px;
}
</style>
